module.exports = __webpack_public_path__ + "static/media/linkedin.de21da3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/linkedin.svg
// module id = 289
// module chunks = 0